"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.retrievePublicUserId = function () {
  var randomNumber = Math.round(Math.random() * Math.pow(10, 10));
  var currentTime = new Date(Date.now());
  return "".concat(randomNumber, ".").concat(currentTime.getDate(), "-").concat(currentTime.getMonth() + 1, "-").concat(currentTime.getFullYear(), ".").concat(currentTime.getHours(), ":").concat(currentTime.getMinutes(), ":").concat(currentTime.getSeconds());
};

var ANALYTICS_UTILS = {
  retrievePublicUserId: exports.retrievePublicUserId
};
exports.default = ANALYTICS_UTILS;